module.exports = __webpack_public_path__ + "img/illus-phone.2a8dad00.svg";